<script lang="ts" setup>
import { useTask, UNMARKED_TAB, HIGH_TAB, DISCARD_TAB } from "@/stores/task";

import ActionBtn from "./ActionBtn.vue";
import { getTaskAction, clickBtn, hideActionBtn } from "./action";

const props = defineProps({
  id: {
    type: Number,
    required: true,
  },
});

const taskStore = useTask();
</script>

<template>
  <div
    v-if="taskStore.selectedType === UNMARKED_TAB"
    class="flex justify-between w-full px-3 pb-3 shadow"
  >
    <div class="flex items-center gap-2">
      <ActionBtn
        v-for="(item, idx) in getTaskAction(id, UNMARKED_TAB, 0)"
        :id="id"
        :key="idx"
        :btn="item"
        extra-class="btn btn-primary"
        @on-click-btn="(btn) => clickBtn(btn, props.id)"
      />
    </div>
    <div class="flex items-center gap-2">
      <ActionBtn
        v-for="(item, idx) in getTaskAction(id, UNMARKED_TAB, 1)"
        :id="id"
        :key="idx"
        :btn="item"
        :is-icon="true"
        @on-click-btn="(btn) => clickBtn(btn, props.id)"
      />
    </div>
  </div>
  <div
    v-if="
      taskStore.selectedType === HIGH_TAB ||
      taskStore.selectedType === DISCARD_TAB
    "
    class="flex flex-col w-full px-0.5 gap-1"
  >
    <div class="flex gap-1">
      <ActionBtn
        v-for="(item, idx) in getTaskAction(id, taskStore.selectedType, 0)"
        :id="id"
        :key="idx"
        :btn="item"
        extra-class="btn btn-primary flex-1"
        @on-click-btn="(btn) => clickBtn(btn, props.id)"
      />
    </div>
    <div class="flex gap-1">
      <ActionBtn
        v-for="(item, idx) in getTaskAction(id, taskStore.selectedType, 1)"
        :id="id"
        :key="idx"
        :btn="item"
        extra-class="btn  flex-1"
        @on-click-btn="(btn) => clickBtn(btn, props.id)"
      />
    </div>
  </div>
</template>
